import "./LoadingBar.scss"

import React from "react"

import animationLine from "../../../constants/animation/loading-line.json"
import LottieAnimation from "../LottieAnimation"

const LoadingBar = ({ width = 400, height = 100 }) => {
  return (
    <div className="loading-bar">
      <LottieAnimation animation={animationLine} width={width} height={height} />
    </div>
  )
}
// LoadingBar.propTypes = {
//   width: PropTypes.number,
//   height: PropTypes.number,
// }

export default LoadingBar
